import { useQuery } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
export var useLicenseDetails = function useLicenseDetails(isOpen) {
  return useQuery(["license_details", isOpen], function () {
    return servicesUtils.getService("/profile/license/details/");
  }, {
    enabled: isOpen
  });
};